export function richviewsRender() { return `<div>
    ${ this.showAvatar ? `<div class="speechCont enter">
        <div class="avatar" style="${  this.__$objToStyleMap(this.avatarStyle)  }"></div>
    </div>`:`` }
    <div class="richBubbleContainer">
        ${ this.showRichInfo ? `<div class="msg-info hide">
            <div class="msg-info-name">${ this.showName ? `<span style="${  this.__$objToStyleMap(this.nameStyle)  }"></span>`:`` }</div>
            <div class="msg-info-time">${ this.showTime ? `<span style="${  this.__$objToStyleMap(this.timeStyle)  }"></span>`:`` }</div>
        </div>`:`` }
    </div>
</div>`  }